export enum ENUM__image_resampling_mode {
  NEAREST = 'nearest',
  BOX = 'box',
  BILINEAR = 'bilinear',
  HAMMING = 'hamming',
  BICUBIC = 'bicubic',
  LANCZOS = 'lanczos',
}
